@if (!isManaging()) {
  <p class="maxx-capabilities__muted body-13-regular">What MAXX can do and what it keeps between conversations.</p>
  <div class="maxx-capabilities__row">
    <div class="maxx-capabilities__row-text">
      <span class="body-14-medium">What MAXX remembers</span>
      <span class="maxx-capabilities__muted body-12-regular">
        @if (isLoading()) {
          Loading…
        } @else if (loadFailed()) {
          Could not load
        } @else {
          {{ visibleMemories().length }} {{ visibleMemories().length === 1 ? 'fact' : 'facts' }} about your brand
        }
      </span>
    </div>
    <pdq-button variant="light" size="small" label="Manage" (onClick)="isManaging.set(true)"></pdq-button>
  </div>
} @else {
  <div class="maxx-capabilities__header">
    <pdq-link label="Back to capabilities" (onClick)="isManaging.set(false)"></pdq-link>
    <span class="body-14-medium">What MAXX remembers</span>
    <span class="maxx-capabilities__muted body-13-regular">
      Facts MAXX saved from your conversations. Removing one stops MAXX from using it.
    </span>
  </div>

  @if (isLoading()) {
    <p class="maxx-capabilities__muted body-13-regular">Loading…</p>
  } @else if (loadFailed()) {
  } @else if (visibleMemories().length === 0) {
    <div class="maxx-capabilities__empty">
      <span class="body-14-medium">Nothing saved yet</span>
      <span class="maxx-capabilities__muted body-13-regular">MAXX saves facts about your brand as you chat.</span>
    </div>
  } @else {
    <ul class="maxx-capabilities__list">
      @for (memory of visibleMemories(); track memory.id) {
        <li class="maxx-capabilities__memory">
          <div
            class="maxx-capabilities__memory-text body-14-regular"
            [appTruncateText]="memory.text"
            (truncatedText)="setShortText(memory.id, $event)">
            @if (isExpanded(memory.id)) {
              <span>{{ memory.text }}</span>
              <button type="button" class="maxx-capabilities__toggle" (click)="toggleExpanded(memory.id)">
                See less
              </button>
            } @else if (isShortened(memory.id)) {
              <span>{{ shortTextOf(memory.id) }}…</span>
              <button type="button" class="maxx-capabilities__toggle" (click)="toggleExpanded(memory.id)">
                See more
              </button>
            } @else {
              <span>{{ memory.text }}</span>
            }
          </div>
          <pdq-button
            variant="ghost"
            size="small"
            icon="delete"
            ariaLabel="Remove memory"
            (onClick)="remove(memory.id)"></pdq-button>
        </li>
      }
    </ul>
    <button type="button" class="maxx-capabilities__clear-all body-14-medium" (click)="clearAll()">Clear all</button>
  }
}

@if (errorMessage()) {
  <p class="maxx-capabilities__error body-13-regular">{{ errorMessage() }}</p>
}

<footer class="save-footer" [ngClass]="hasPendingChanges() ? 'apear' : 'initial'">
  <span>You have {{ pendingRemovals().size }} unsaved {{ pendingRemovals().size === 1 ? 'change' : 'changes' }}</span>
  <pdq-button
    variant="secondary"
    label="cancel"
    class="action-btn"
    [disabled]="isSaving()"
    (onClick)="cancel()"></pdq-button>
  <pdq-button variant="primary" label="save" class="action-btn" [loading]="isSaving()" (onClick)="save()"></pdq-button>
</footer>
